import axios from "axios";
import api from "./endpoints";
import { notify } from "../utils/Notify";

const checkAiCreditsUrl = `${api.baseApi}/api/update_jgate_credits_and_get_balance/`;

export type FeatureKey = "insight_hub_keywords" | "insight_hub_summary";

export async function checkAiCredits(featureKey: FeatureKey): Promise<boolean> {
  try {
    const profileId = sessionStorage.getItem("user_id");
    const customerId = sessionStorage.getItem("informaticscustomer_id") || "";

    if (!profileId) {
      return true;
    }

    const response = await axios.get(checkAiCreditsUrl, {
      params: {
        profile_id: profileId,
        customer_id: customerId,
      },
      headers: {
        Accept: "application/json",
      },
    });

    console.log("CHECK FEATURE ACCESS RESPONSE", response);

    if (response.status === 200) {
      const permissions = response.data?.data;

      if (permissions && permissions[featureKey] === false) {
        notify(
          "error",
          "Your current AI credit balance is insufficient to process this query.\nPlease contact your Institute administrator for assistance.",
          {
            autoClose: 10000,
          },
        );

        return false;
      }

      return true;
    }

    return false;
  } catch (error) {
    console.log("Error", error);

    notify("error", "Something went wrong. Please try again later.");

    return false;
  }
}
